import { api } from '../api';

export interface TournamentForMigration {
  id: string;
  name: string;
  status: string;
  buyIn: number;
  rake: number;
  totalBuyin: number;
  maxPlayers: number;
  registeredPlayers: number;
  availableSlots: number;
}

export interface MigrationResult {
  playerId: string;
  playerAddress: string;
  success: boolean;
  transactionId?: string;
  error?: string;
}

export interface MigrationSummary {
  sourceTournamentId: string;
  destinationTournamentId: string;
  totalPlayers: number;
  successful: number;
  failed: number;
  results: MigrationResult[];
  startedAt: Date;
  completedAt: Date;
  previouslyMigrated?: number;
  attemptedInThisRun?: number;
}

class TournamentMigrationService {
  /**
   * Get list of tournaments available for migration
   */
  async getTournamentsForMigration(excludeId?: string): Promise<TournamentForMigration[]> {
    const url = excludeId
      ? `/v1/admin/tournaments/migration/available?excludeId=${excludeId}`
      : `/v1/admin/tournaments/migration/available`;

    const response = await api.get<TournamentForMigration[]>(url);

    return response.data;
  }

  /**
   * Migrate players from source tournament to destination tournament
   */
  async migratePlayers(
    sourceTournamentId: string,
    destinationTournamentId: string,
  ): Promise<{ success: boolean; summary?: MigrationSummary; error?: string }> {
    const response = await api.post(`/v1/admin/tournaments/migration/migrate`, {
      sourceTournamentId,
      destinationTournamentId,
    });

    return response.data;
  }
}

export default new TournamentMigrationService();
